var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "standard-config-container" },
    [
      _c("div", { staticClass: "config-header" }, [
        _c("h4", [
          _vm._v("参数：" + _vm._s(_vm.currentStandardParam.paramName)),
        ]),
        _c("p", [_vm._v("设置该参数的标准值或标准值范围")]),
      ]),
      _c(
        "el-form",
        {
          ref: "standardFormRef",
          attrs: {
            model: _vm.standardForm,
            rules: _vm.standardFormRules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标准值类型", prop: "standardType" } },
            [
              _c("ic-select", {
                staticStyle: { width: "100%" },
                attrs: { table: "TT_PROC", field: "STANDARD_TYPE" },
                model: {
                  value: _vm.standardForm.standardType,
                  callback: function ($$v) {
                    _vm.$set(_vm.standardForm, "standardType", $$v)
                  },
                  expression: "standardForm.standardType",
                },
              }),
            ],
            1
          ),
          _vm.standardForm.standardType === "SINGLE"
            ? _c(
                "el-form-item",
                { attrs: { label: "标准值", prop: "standard" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入标准值" },
                    model: {
                      value: _vm.standardForm.standard,
                      callback: function ($$v) {
                        _vm.$set(_vm.standardForm, "standard", $$v)
                      },
                      expression: "standardForm.standard",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.standardForm.standardType === "RANGE"
            ? _c(
                "el-form-item",
                { attrs: { label: "最小值", prop: "minValue" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入最小值" },
                    model: {
                      value: _vm.standardForm.minValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.standardForm, "minValue", $$v)
                      },
                      expression: "standardForm.minValue",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.standardForm.standardType === "RANGE"
            ? _c(
                "el-form-item",
                { attrs: { label: "最大值", prop: "maxValue" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入最大值" },
                    model: {
                      value: _vm.standardForm.maxValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.standardForm, "maxValue", $$v)
                      },
                      expression: "standardForm.maxValue",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.standardForm.standardType === "OPERATOR"
            ? _c(
                "el-form-item",
                { attrs: { label: "操作符", prop: "operator" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "选择操作符" },
                      model: {
                        value: _vm.standardForm.operator,
                        callback: function ($$v) {
                          _vm.$set(_vm.standardForm, "operator", $$v)
                        },
                        expression: "standardForm.operator",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "大于 (>)", value: ">" },
                      }),
                      _c("el-option", {
                        attrs: { label: "大于等于 (>=)", value: ">=" },
                      }),
                      _c("el-option", {
                        attrs: { label: "小于 (<)", value: "<" },
                      }),
                      _c("el-option", {
                        attrs: { label: "小于等于 (<=)", value: "<=" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.standardForm.standardType === "OPERATOR"
            ? _c(
                "el-form-item",
                { attrs: { label: "比较值", prop: "operatorValue" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入比较值" },
                    model: {
                      value: _vm.standardForm.operatorValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.standardForm, "operatorValue", $$v)
                      },
                      expression: "standardForm.operatorValue",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center", align: "middle" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.onSave },
            },
            [_vm._v("保存设置")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.onCancel },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }